export const QUERY_EXECUTE_SAGA = "QUERY_EXECUTE_SAGA";
export const QUERY_EXECUTE_SUCCESS = "QUERY_EXECUTE_SUCCESS";
export const QUERY_EXECUTE_FAILURE = "QUERY_EXECUTE_FAILURE";
export const QUERY_RESET_SAGA = "RESET_QUERY_SAGA";
export const QUERY_RESET_RESULTS_SAGA_FINISHED =
    "QUERY_RESET_RESULTS_SAGA_SUCCESS";
export const QUERY_RESET_RESULTS_SAGA = "QUERY_RESET_RESULTS_SAGA";
